module.exports = __webpack_public_path__ + "static/media/login.cba154e7.svg";